import React from "react";
import styles from "./DegradeFond.module.css";

/**
 * Fond plein écran « Dégradé » du mode Publicité : deux grandes nappes de couleur aux tons d'AkitaTek qui dérivent lentement
 * l'une sur l'autre. Dessin et code originaux ; deux déplacements `transform`, rien d'autre.
 */
export default function DegradeFond() {
    return (
        <div className={styles.scene} aria-hidden="true">
            <div className={`${styles.nappe} ${styles.une}`}/>
            <div className={`${styles.nappe} ${styles.deux}`}/>
        </div>
    );
}
